import React from "react";
import ContactUs from "./ContactUs";
import "./React.css";
import ReactPDF from "../assets/Front End Development with ReactJS Codex Future Syllabus.pdf";

const Reactt = () => {
  return (
    <>
     

      <section className="react-section">
        <div className="react-container">
          <h1 className="react-title">Introduction to ReactJS Course</h1>
          <h3 className="react-subtitle">Front-End Website Development</h3>
          <p className="react-rating">(4.8 Reviews)</p>
          <p className="react-duration">Duration: 2 Months | 10+ Guaranteed Interviews</p>

          <p className="react-description">
            Learn from the <strong>Best ReactJS Training in Indore</strong> with expert React mentors at 
            <strong> Codex Future</strong>. Our goal is to teach you from fundamentals to advanced ReactJS 
            techniques through comprehensive, hands-on sessions.
          </p>

          <p className="react-text">
            The hands-on learning sessions will teach you about component design, state management, and 
            advanced concepts required to build modern, scalable web applications using 
            <strong> React.js</strong>, <strong>Flux</strong>, and <strong>Redux</strong>. This course is perfect 
            for anyone aspiring to become a skilled front-end developer.
          </p>

          <button className="react-btn" 
          onClick={() => window.open(ReactPDF, "_blank")}
          >📘 Download Syllabus</button>
        </div>
      </section>

      <ContactUs />
      
    </>
  );
};

export default Reactt;
